export default __webpack_public_path__ + "static/media/renewable-energy.b5187e43.png";